import { BtnModalOpen, BtnModalClose } from './BtnModal'

export {
  BtnModalOpen,
  BtnModalClose
}